const API_URL = process.env.REACT_APP_API_URL || '';
const API_HOST = API_URL.replace(/\/api\/v1\/?$/, '');

export const getApiUrl = () => API_URL;
export const getApiHost = () => API_HOST;

/**
 * Resolves relative media URLs to absolute URLs using backend host.
 */
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return `${API_HOST}${url}`;
  return `${API_HOST}/${url}`;
};

/**
 * Helper to get primary display image and hover image for product cards
 */
export const getProductCardImages = (product) => {
  if (!product) return { image: '', hoverImage: '' };
  
  // Shared product images first (not tied to a metal finish); legacy products
  // with only per-finish images fall back to the default variant's images.
  let primaryImageObj = null;
  let hoverImageObj = null;

  if (product.images && product.images.length > 0) {
    const sorted = [...product.images].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    primaryImageObj = sorted[0];
    hoverImageObj = sorted.find(img => img.isHover && img.id !== primaryImageObj.id) || sorted[1] || primaryImageObj;
  } else {
    const variants = product.variants || [];
    const defaultVariant = variants.find(v => v.isDefault) || variants[0];
    if (defaultVariant && defaultVariant.images && defaultVariant.images.length > 0) {
      primaryImageObj = defaultVariant.images.find(img => img.isPrimary) || defaultVariant.images[0];
      hoverImageObj = defaultVariant.images.find(img => img.id !== primaryImageObj?.id) || primaryImageObj;
    }
  }

  // Fallback to top-level image properties if present
  // Cards use the small generated thumbnail when available; the full-size
  // image is only loaded on the product detail page.
  const primaryUrl = primaryImageObj?.thumbnailUrl || primaryImageObj?.url || product.image || '';
  const hoverUrl = hoverImageObj?.thumbnailUrl || hoverImageObj?.url || product.hoverImage || primaryUrl;

  return {
    image: resolveImageUrl(primaryUrl),
    hoverImage: resolveImageUrl(hoverUrl),
  };
};

/**
 * Centralized API client functions
 */

export const fetchProducts = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/products${query ? `?${query}` : ''}`);
    const json = await res.json();
    if (json.success && json.data) {
      return json.data.products || json.data || [];
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch products:', error);
    return [];
  }
};

export const fetchProductById = async (id) => {
  try {
    const res = await fetch(`${API_URL}/products/${encodeURIComponent(id)}`);
    const json = await res.json();
    if (json.success && json.data) {
      return json.data;
    }
    return null;
  } catch (error) {
    console.error(`Failed to fetch product ${id}:`, error);
    return null;
  }
};
